/** Locale keys for SERVICE_CATALOG + category guide timelines (see public/locales/te.xml). */

export function serviceTitle(code, t, fallback) {
  return t(`svc.${code}.title`, fallback);
}

export function serviceDesc(code, t, fallback) {
  return t(`svc.${code}.desc`, fallback);
}

export function categoryTimeline(category, t, fallback) {
  return t(`guide.timeline.${category}`, fallback);
}
